<div class="no-data-wrapper" [ngClass]="fullHeight ? 'fullHeight' : null">
  <img src="/assets/img/buzz/buzz-shrugging-gray.png" alt="" />
  <p>
    <span class="bold-text">{{ dataNotice.title_1.text | translate }}</span>
    <br />
    <span [innerHTML]="dataNotice.title_2.text | translate"></span>
  </p>
</div>
